﻿import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';
import { format } from 'common/functions/string';

export class ConfirmWorkTrayViewDeletionDialog implements IDialog {
    private dialogContent: JQuery;
    options: IDialogOptions;

    constructor(viewName: string, resources: IResourceProvider, action: (dialog: JQuery) => void) {
        var messageFormat = resources.getCoreString('MsgConfirmViewDeletion');
        this.dialogContent = $('<div />').text(format(messageFormat, viewName));

        this.options = {
            title: resources.getCoreString('MsgConfirmViewDeletionTitle'),
            width: 400,
            height: 200,
            dialogClass: 'wf-view-dialog',
            buttons: [
                { text: resources.getCoreString('XamlProceed'), click: () => action(this.dialogContent) },
                { text: resources.getCoreString('XamlClose'), click: () => this.dialogContent.dialog('close') }
            ],
            create: () => $('.ui-dialog-buttonset button', this.dialogContent.parent()).css({ 'min-width': '80px', height: '25px' })
        };
    }

    content(): JQuery {
        return this.dialogContent;
    }
}